import { ClientEventEmitter } from '../../marketing/ClientEventEmitter';
import '../../vendor/jquery.cookie-1.4.1';
import consoleLogger from '../../logger/consoleLogger';
import { ClientEvents } from '../../constants/clientEvents';
import { GtmSender } from '../../marketing/GtmSender';
import { GameEvents, SystemEvents } from '../../constants/gameEvents';
import { PixelEvents } from '../../marketing/PixelEvents';
import { PaymentObject } from '../../types/payments';
import { setPaymentEventsListeners } from './paymentEvents';
import { WebGuestWarningPopup } from './webGuestWarningPopup';
import { GetGameStartDataResponse } from '../../types/server';

type EventLevelUp = {
    level: number
};

const logger = consoleLogger.getPrefixedCopy('APP_EVENTS');

/** WEB EVENTS **/
window.app.eventInstall = onInstall;
window.app.notInstall = onNotInstall;
window.app.firtsDayRetention = onFirstDayRetention;
window.app.eventRetention = onRetention;
window.app.eventPreregLanding = onPreregLanding;
window.app.eventPreregConfirm = onPreregConfirm;
window.app.eventPreregComplete = onPreregComplete;
window.app.fireInitiateCheckout = onInitiateCheckout;
/** WEB EVENTS **/


/* for notInstall event. */
function setInstallCookie() {
    try {
        const date = new Date();
        const dayEnd = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()} 23:59:59`;
        const ts = new Date(dayEnd).getTime();

        $.cookie('installCookie', ts, { expires: 1, path: '/', domain: `.${window.app.config.domain}`, secure: true });
    } catch (error) {
        console.error(error);
    }
}

function hasInstallCookie() {
    return $.cookie('installCookie');
}

function onInstall() { // вызываем сами
    ClientEventEmitter.fireEvent(ClientEvents.INSTALL);
    logger.info('app.eventInstall');
    setInstallCookie();
    GtmSender.fireMarketing(SystemEvents.INSTALL);
    logger.info('app.eventInstall::end');
}

function onNotInstall() { // вызываем сами
    ClientEventEmitter.fireEvent(ClientEvents.NOT_INSTALL);
    logger.info('app.notInstall');
    try {
        if (hasInstallCookie()) {
            logger.info('app.notInstall::hasInstallCookie');
        }
    } catch (error) {
        window.Sentry.captureException(error);
    }
    logger.info('app.notInstall::end');
}

function onFirstDayRetention() { // вызываем сами
    ClientEventEmitter.fireEvent(ClientEvents.FIRST_DAY_RETENTION);
    logger.info('app.firtsDayRetention');
    logger.info('app.firtsDayRetention::end');
}

function onRetention(retentionDay: number) {
    ClientEventEmitter.fireEvent(ClientEvents.N_DAY_RETENTION, { day: retentionDay });
}

function onPreregLanding() {
    GtmSender.firePrereg(SystemEvents.LANDING);
    ClientEventEmitter.fireEvent(ClientEvents.PREREG_LANDING);
}


function onPreregConfirm() {
    GtmSender.firePrereg(SystemEvents.PREREG_CONFIRM);
    ClientEventEmitter.fireEvent(ClientEvents.PREREG_CONFIRM);
}

function onPreregComplete() {
    GtmSender.firePrereg(SystemEvents.PREREG_COMPLETE);
    ClientEventEmitter.fireEvent(ClientEvents.PREREG_COMPLETE);
}

function onInitiateCheckout(paymentObject: PaymentObject) {
    ClientEventEmitter.fireEvent(ClientEvents.INITIATE_CHECKOUT, { paymentObject });
}


function eventInstallHandler(_event: Event) {
    GtmSender.fireMarketing(PixelEvents.INSTALL);
}

function eventCityLevelUpHandler(_event: Event, data: EventLevelUp) {
    GtmSender.fireMarketing(
        GameEvents.CAPITOL_LEVELING + data.level,
        {
            capitolLevel: data.level
        }
    );
}

function eventHeroLevelUpHandler(_event: Event, data: EventLevelUp) {
    GtmSender.fireMarketing(
        GameEvents.HERO_LEVELING + data.level,
        {
            heroLevel: data.level
        }
    );

    if (data.level > 5) {
        GtmSender.fireMarketing(GameEvents.HERO_UPGRADE);
    }
}

function eventFirstClickHandler() {
    GtmSender.fireClient(ClientEvents.FIRST_CLICK);
}

function eventShowPreloaderHandler() {
    GtmSender.fireClient(ClientEvents.SHOW_PRELOADER);
}

function eventHidePreloaderHandler() {
    GtmSender.fireClient(ClientEvents.HIDE_PRELOADER);
}

function eventServerLoginHandler() {
    logger.info('app.eventServerLogin');
    try {
        GtmSender.fireMarketing(SystemEvents.SERVER_LOGIN);
    } catch (error) {
        window.Sentry.captureException(error);
    }
    logger.info('app.eventServerLogin::end');
}

function event100ClicksHandler() {
    logger.info('app.event100clicks');
    WebGuestWarningPopup.showWebGuestNotificationWindow();
    try {
        GtmSender.fireMarketing(GameEvents.CLICKS_100);
        GtmSender.fireClient('100clicks');
    } catch (error) {
        window.Sentry.captureException(error);
    }
    logger.info('app.event100clicks::end');
}

function eventMonsterLvl5() {
    GtmSender.fireMarketing(GameEvents.MONSTER_LVL_5);
}

function eventValorMonster1000() {
    GtmSender.fireMarketing(GameEvents.VALOR_MONSTER_1000);
}

function eventUnitsTrainSilver10k() {
    GtmSender.fireMarketing(GameEvents.UNITS_TRAIN_SILVER_10000);
}

function eventMarches9() {
    GtmSender.fireMarketing(GameEvents.MARCHES_9);
}

function eventValorMonster1000perMarch() {
    GtmSender.fireMarketing(GameEvents.VALOR_MONSTER_1000_PER_MARCH);
}

export function setClientEventListeners() {
    ClientEventEmitter.one<EventLevelUp>(ClientEvents.INSTALL, eventInstallHandler);
    ClientEventEmitter.on<EventLevelUp>(ClientEvents.CITY_LEVEL_UP, eventCityLevelUpHandler);
    ClientEventEmitter.on<EventLevelUp>(ClientEvents.HERO_LEVEL_UP, eventHeroLevelUpHandler);
    ClientEventEmitter.one(ClientEvents.HIDE_PRELOADER, eventHidePreloaderHandler);
    ClientEventEmitter.one(ClientEvents.SERVER_LOGIN, eventServerLoginHandler);
    ClientEventEmitter.one(ClientEvents.TUTORIAL_100_CLICKS, event100ClicksHandler);
    ClientEventEmitter.one(ClientEvents.FIRST_CLICK, eventFirstClickHandler);
    ClientEventEmitter.one(ClientEvents.SHOW_PRELOADER, eventShowPreloaderHandler);
    ClientEventEmitter.one(ClientEvents.MONSTER_LVL_5, eventMonsterLvl5);
    ClientEventEmitter.one(ClientEvents.VALOR_MONSTER_1000, eventValorMonster1000);
    ClientEventEmitter.one(ClientEvents.VALOR_MONSTER_1000_PER_MARCH, eventValorMonster1000perMarch);
    ClientEventEmitter.one(ClientEvents.UNITS_TRAIN_SILVER_10000, eventUnitsTrainSilver10k);
    ClientEventEmitter.one(ClientEvents.MARCHES_9, eventMarches9);
    setPaymentEventsListeners();
}

export function isRetentionUser(response: GetGameStartDataResponse) {
    if (response?.fdretention === 1) {
        window.app.firtsDayRetention();
    }

    if (response?.ret1 === true) {
        window.app.eventRetention(1);
    }

    if (response?.ret7 === true) {
        window.app.eventRetention(7);
    }
}

export function eventWebGuestHasSwitchedGameProgress(): void {
    GtmSender.fireMarketing(GameEvents.WEB_GUEST_HAS_SWITCHED_GP);
}
